// extracted by mini-css-extract-plugin
export var quantityInput = "_mi-0";